import { createElement } from 'react';
interface Props {
	name: string;
	className?: string;
	onClick?: () => void;
}

// List of available analyse icons : https://app.autodeskforma.eu/design-system/v2/docs/?path=/story/forma-components-icons-analyse--all
// List of available common icons : https://app.autodeskforma.eu/design-system/v2/docs/?path=/story/forma-components-icons-common--all
export const Icon = (props: Props) => {
	const { name, className, onClick } = props;

	let mergedClassName = className;

	if (onClick) {
		mergedClassName = `${className} cursor-pointer`;
	}

	return createElement(name, { className: mergedClassName, onClick });
};
